import { Card } from '@/components/elements/cards';
import { Link, h4Class } from '@/components/elements/content';
import { CheckIcon } from '@/components/icons';
import { _sTitle, _t } from '@/locale/i18n';

const baseTranslationKey = `components.templates.giftCards.InfoColumn`;

const InfoColumn = ({ description, placeName }: { description: string; placeName: string }) => {
  const infoCheckList = _t(`${baseTranslationKey}.checks`);
  const smallText = _t(`${baseTranslationKey}.smallText`);

  return (
    <div className="mb-xl sticky">
      <div className="shadow">
        <div className="border-border_regular mt-xl border border-b-0">
          <picture>
            <source srcSet={'/images/product-info-vc-placecard-desktop-2xl.png'} media="(min-width: 1900px)" />
            <source srcSet={'/images/product-info-vc-placecard-desktop-lg.png'} media="(min-width: 768px)" />
            <img
              src={'/images/product-info-vc-placecard-mobile.png'}
              className="h-auto w-full object-cover object-center"
              alt=""
            />
          </picture>
        </div>
        <Card noShadow attachedTop>
          {infoCheckList.map((check, i) => (
            <div key={i}>
              <div className="flex items-center justify-start">
                <CheckIcon className="color-primary mr-xs w-sm" /> <strong>{check.title}</strong>
              </div>
              <div className="text-fg_secondary mb-sm ml-xl">{check.desc}</div>
            </div>
          ))}
          <p className="text-fg_secondary my-sm text-sm">{smallText}</p>
          <h3 className={h4Class}>{_sTitle(`${baseTranslationKey}.aboutPlace`, { name: placeName })}</h3>
          <p>{description}</p>
        </Card>
      </div>
      <div className="flex justify-center">
        <div>
          <span>{_t(`${baseTranslationKey}.use`)}</span>{' '}
          <Link to="/giftcards" className="!no-underline">
            {' '}
            {_t(`${baseTranslationKey}.useLink`)}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InfoColumn;
